import '../../types'

let CURRENT_SEER
let CURRENT_SEER_DATA

/** @type {guest.maurice.setCurrentSeer} */
export const setCurrentSeer = (cs, data) => {
  CURRENT_SEER = cs
  CURRENT_SEER_DATA = data
}

/** @type {guest.maurice.proxifyState} */
export default function proxifyState(state) {
  const seersMap = {}
  const proxyState = {}
  const currentProps = Object.getOwnPropertyDescriptors(state)
  Object.defineProperties(proxyState, currentProps)

  for (const prop in state) {
    // let val = c.value
    // what if some already were defined with getters
    Object.defineProperty(state, prop, {
      get() {
        if (CURRENT_SEER) {
          const seer = { seer: CURRENT_SEER, data: CURRENT_SEER_DATA }
          /** @type {!Set} */
          let seers = seersMap[prop]
          if (!seers) {
            seers = new Set()
            seersMap[prop] = seers
          }
          seers.add(seer)
        }
        return proxyState[prop]
      },
      set(value) {
        const prevValue = proxyState[prop]
        if (prevValue === value) return
        proxyState[prop] = value
        /** @type {!Set<{ seer: !guest.maurice.IStatefulSeer, data }>} */
        const seers = seersMap[prop]
        if (seers) {
          for (const { seer, data } of seers) {
            seer.__$see({
              data,
              // derivedStateProp: data, // this might be a paint method
              sourceState: state, sourceStateProp: prop, sourceStateValue: value,
            })
            // notify llistener of the change
          }
        }
      },
    })
    // if (val) state[prop] = val
  }
}